import { Slider } from "@/components/ui/slider"

interface RelevanceFilterProps {
    onRelevanceChange: (value: number) => void;
    relevanceThreshold: number;
    resultCount?: number;
    totalResults?: number;
}

const RelevanceFilter = ({
    onRelevanceChange,
    relevanceThreshold,
    resultCount,
    totalResults
}: RelevanceFilterProps) => {
    return (
        <div className="mb-4">
            {/* Results count header */}
            {resultCount !== undefined && totalResults !== undefined && (
                <div className="flex items-center justify-between mb-4">
                    <span className="text-sm text-muted-foreground">
                        Showing {resultCount} of {totalResults} results
                    </span>
                </div>
            )}

            {/* Relevance Filter */}
            <div className="space-y-2">
                <span className="text-sm text-muted-foreground block">
                    Minimum relevance: {relevanceThreshold}%
                </span>
                <Slider
                    value={[relevanceThreshold]}
                    onValueChange={(value) => onRelevanceChange(value[0])}
                    min={0}
                    max={100}
                    step={5}
                    className="[&_.slider-track]:bg-gray-600 [&_.slider-range]:bg-blue-800 [&_[role=slider]]:bg-blue-600 [&_[role=slider]]:border-blue-600 [&_[role=slider]]:hover:bg-blue-700 [&_[role=slider]]:focus:ring-blue-500 dark:[&_.slider-track]:bg-gray-600"
                />
            </div>
        </div>
    );
};

export default RelevanceFilter;